var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-qa-engine" }, [
    _c("div", { staticClass: "device-header" }, [
      _c("div", { staticClass: "device-left" }, [
        _c("img", {
          staticClass: "device-icon",
          attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" }
        }),
        _c(
          "div",
          {
            staticClass: "device-light-btn",
            on: { click: _vm.onclickLightBtn }
          },
          [_vm._v("亮灯")]
        )
      ]),
      _c("div", { staticClass: "device-num" }, [
        _c("div", [_vm._v("imei: " + _vm._s(_vm.info.displayImei))]),
        _c("div", [_vm._v("iccid: " + _vm._s(_vm.info.displayIccid))])
      ])
    ]),
    _c("div", { staticClass: "steps" }, [
      _c("div", { staticClass: "step-item" }, [
        _c("div", { staticClass: "step-left" }, [
          _c("div", { staticClass: "step-info" }, [
            _c("div", { staticClass: "step-label" }, [
              _vm._v("1.录入设备编号")
            ]),
            _vm.step1Status == 1 && _vm.uniqueId
              ? _c("div", { staticClass: "step-sub" }, [
                  _vm._v("（" + _vm._s(_vm.uniqueId) + "）")
                ])
              : _vm._e()
          ]),
          _vm.step1Status == 3
            ? _c(
                "span",
                { staticClass: "step-icon loading" },
                [_c("Loading", { attrs: { type: "spinner", size: "0.2rem" } })],
                1
              )
            : _vm.step1Status == 1
            ? _c("i", { staticClass: "step-icon van-icon van-icon-checked" })
            : _vm.step1Status == 2
            ? _c("i", { staticClass: "step-icon err van-icon van-icon-clear" })
            : _vm._e()
        ]),
        _c("div", { staticClass: "step-action" }, [
          _vm.step5Status == 1
            ? _c("div", { staticClass: "step-text" }, [_vm._v("已完成")])
            : _c("div", { staticClass: "step-action-btns" }, [
                _c(
                  "div",
                  {
                    staticClass: "step-btn",
                    on: { click: _vm.onclickManualBtn }
                  },
                  [_vm._v("手动输入")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "step-btn",
                    on: { click: _vm.onclickScanBtn }
                  },
                  [_vm._v("扫码")]
                )
              ])
        ])
      ]),
      _c("div", { staticClass: "step-item" }, [
        _c("div", { staticClass: "step-left" }, [
          _c("div", { staticClass: "step-info" }, [
            _c("div", { staticClass: "step-label" }, [
              _vm._v("2.远程打样测试")
            ]),
            _vm.step2Status == 2 && _vm.step2FailReason
              ? _c("div", { staticClass: "step-sub fail" }, [
                  _vm._v(_vm._s(_vm.step2FailReason))
                ])
              : _vm._e()
          ]),
          _vm.step2Status == 3
            ? _c(
                "span",
                { staticClass: "step-icon loading" },
                [_c("Loading", { attrs: { type: "spinner", size: "0.2rem" } })],
                1
              )
            : _vm.step2Status == 1
            ? _c("i", { staticClass: "step-icon van-icon van-icon-checked" })
            : _vm.step2Status == 2
            ? _c("i", { staticClass: "step-icon err van-icon van-icon-clear" })
            : _vm._e()
        ]),
        _c("div", { staticClass: "step-action" }, [
          _vm.step5Status == 1
            ? _c("div", { staticClass: "step-text" }, [_vm._v("已完成")])
            : _vm.step2Status == 3
            ? _c("div", { staticClass: "step-text yellow" }, [_vm._v("检测中")])
            : _vm.step2Status == 0
            ? _c(
                "div",
                {
                  staticClass: "step-btn",
                  on: { click: _vm.onclickRemoteTestBtn }
                },
                [_vm._v("检测")]
              )
            : _c(
                "div",
                {
                  staticClass: "step-btn",
                  on: { click: _vm.onclickRemoteTestBtn }
                },
                [_vm._v("重检")]
              )
        ])
      ]),
      _vm.step2Status == 1
        ? _c(
            "div",
            { staticClass: "confirm-bar", on: { click: _vm.openMediaModal } },
            [
              _c("span", { staticClass: "confirm-text" }, [
                _vm._v("人工确认打样信息")
              ]),
              _c("span", { staticClass: "confirm-btn" }, [_vm._v("去查看")])
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "step-item" }, [
        _c("div", { staticClass: "step-left" }, [
          _c("div", { staticClass: "step-label" }, [_vm._v("3.手动按键测试")]),
          _vm.step3Status == 1
            ? _c("i", { staticClass: "step-icon van-icon van-icon-checked" })
            : _vm._e()
        ]),
        _c("div", { staticClass: "step-action" }, [
          _vm.step3Status == 1
            ? _c("div", { staticClass: "step-text" }, [_vm._v("已完成")])
            : _c("div", { staticClass: "step-text" }, [_vm._v("待手动按键")])
        ])
      ]),
      _c("div", { staticClass: "step-item" }, [
        _c("div", { staticClass: "step-left" }, [
          _c("div", { staticClass: "step-info" }, [
            _c("div", { staticClass: "step-label" }, [_vm._v("4.信号强度")]),
            _vm.step4Status == 2
              ? _c("div", { staticClass: "step-sub fail" }, [
                  _vm._v(
                    "当前信号 " +
                      _vm._s(_vm.displaySignal) +
                      "，要求≥" +
                      _vm._s(_vm.signalRequired)
                  )
                ])
              : _vm._e()
          ]),
          _vm.step4Status == 1
            ? _c("i", { staticClass: "step-icon van-icon van-icon-checked" })
            : _vm.step4Status == 2
            ? _c("i", { staticClass: "step-icon err van-icon van-icon-clear" })
            : _vm._e()
        ]),
        _c("div", { staticClass: "step-action" }, [
          _vm.step4Status == 1
            ? _c("div", { staticClass: "step-text" }, [_vm._v("已通过")])
            : _vm.step4Status == 2
            ? _c("div", { staticClass: "step-text" }, [_vm._v("不通过")])
            : _vm._e()
        ])
      ]),
      _c("div", { class: ["step-item", { disabled: !_vm.firstFourDone }] }, [
        _c("div", { staticClass: "step-left" }, [
          _c("div", { staticClass: "step-info" }, [
            _c("div", { staticClass: "step-label" }, [
              _vm._v("5.重启并切换到线上环境")
            ]),
            _vm.step5Status == 2
              ? _c("div", { staticClass: "step-sub fail" }, [
                  _vm._v("注册超时，请重试")
                ])
              : _vm._e()
          ]),
          _vm.step5Status == 3
            ? _c(
                "span",
                { staticClass: "step-icon loading" },
                [_c("Loading", { attrs: { type: "spinner", size: "0.2rem" } })],
                1
              )
            : _vm.step5Status == 1
            ? _c("i", { staticClass: "step-icon van-icon van-icon-checked" })
            : _vm.step5Status == 2
            ? _c("i", { staticClass: "step-icon err van-icon van-icon-clear" })
            : _vm._e()
        ]),
        _c("div", { staticClass: "step-action" }, [
          _vm.step5Status == 1
            ? _c("div", { staticClass: "step-text" }, [_vm._v("已完成")])
            : _vm.firstFourDone &&
              (_vm.step5Status == 0 || _vm.step5Status == 2)
            ? _c(
                "div",
                {
                  staticClass: "step-btn",
                  on: { click: _vm.onclickRestartBtn }
                },
                [_vm._v("重启")]
              )
            : !_vm.firstFourDone
            ? _c("div", { staticClass: "step-text" }, [
                _vm._v("待上述4项质检完毕")
              ])
            : _vm._e()
        ])
      ])
    ]),
    _c("div", { staticClass: "footer" }, [
      _vm.mode == "check"
        ? _c(
            "div",
            {
              class: ["btn-submit", { disabled: !_vm.canSubmit }],
              on: { click: _vm.onclickSubmitBtn }
            },
            [_vm._v("单独提交质检")]
          )
        : _vm._e()
    ]),
    _vm.showMediaModal
      ? _c(
          "div",
          {
            staticClass: "media-modal",
            on: {
              touchmove: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "media-box" }, [
              _vm.currentIndex === 0 && _vm.videoUrl
                ? _c("video", {
                    ref: "mediaVideo",
                    attrs: {
                      controls: "",
                      playsinline: "",
                      "webkit-playsinline": "",
                      src: _vm.videoUrl,
                      poster: _vm.picUrl
                    }
                  })
                : _c("img", {
                    attrs: { src: _vm.picUrl },
                    on: {
                      click: function($event) {
                        _vm.showPreviewImg = true
                      }
                    }
                  })
            ]),
            _vm.picUrl
              ? _c("div", { staticClass: "media-list" }, [
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      class: { active: _vm.currentIndex === 0 },
                      on: {
                        click: function($event) {
                          return _vm.changeMediaIndex(0)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "img-box" }, [
                        _c("img", { attrs: { src: _vm.picUrl } }),
                        _c("div", { staticClass: "play-icon" })
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      class: { active: _vm.currentIndex === 1 },
                      on: {
                        click: function($event) {
                          return _vm.changeMediaIndex(1)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "img-box" }, [
                        _c("img", { attrs: { src: _vm.picUrl } })
                      ])
                    ]
                  )
                ])
              : _c("div", { staticClass: "media-empty" }, [
                  _vm._v("未获取到视频和照片")
                ]),
            _c("img", {
              staticClass: "close-btn",
              attrs: {
                src:
                  "https://static.yudada.com/wechat/pond/img/icon_close_modal.png"
              },
              on: { click: _vm.closeMediaModal }
            }),
            _vm.showPreviewImg
              ? _c(
                  "div",
                  {
                    staticClass: "preview-mask",
                    on: {
                      click: function($event) {
                        _vm.showPreviewImg = false
                      }
                    }
                  },
                  [_c("img", { attrs: { src: _vm.picUrl } })]
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }